var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.resolveLayoutVariant,{tag:"component",class:`skin-variant--${_vm.appSkinVariant}`},[(_vm.name==='form')?_c('widget-form',{attrs:{"params":_vm.params}}):_c('transition',{attrs:{"name":_vm.appRouteTransition,"mode":"out-in","appear":""}},[_c('router-view',{key:_vm.$route.name})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }